import { render, staticRenderFns } from "./checkboxss.vue?vue&type=template&id=f3c9e108&"
import script from "./checkboxss.vue?vue&type=script&lang=js&"
export * from "./checkboxss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports